<mat-toolbar class="header" [ngStyle]="{'background-color': _appsService.projectColorCode ? _appsService.projectColorCode : (_appsService.companyColorCode ? _appsService.companyColorCode : '#ffffff' )}" style="height: 70px !important;" #header>
  <div style="width: 100%; display: flex; align-items: center; justify-content: space-between; height:100%">    
    <div class="header__title">
      <!--<button class="header__title-button" mat-mini-fab (click)="openMenu()" color="primary" #headerTile>
      <mat-icon *ngIf="!isMenuOpened" class="header__title-button-icon">menu</mat-icon>
      <mat-icon *ngIf="isMenuOpened" class="header__title-button-icon">menu</mat-icon>
    </button>-->
      <h1 *ngIf="_appsService.defaultLogo" class="app-workforce">
        <a style="text-decoration-line: none;display: flex;align-items: center;justify-content: center;">
          <img class="logo" [src]="_appsService.defaultLogo" alt="company" style="max-width: 130px; max-height: 70px;">
        </a>
      </h1>
    </div>

    <div style="width:100%; display:flex; justify-content:center; height:100%;">
    </div>
    <div class="header-toolbar" style="height:100%;">
      <!--<mat-form-field *ngIf="_appsService.isAdmin" style="margin-left:10px; width:125px;margin-right:10px; ">
      <mat-select #searchCompany style="font-size: 15px;" [(value)]="_appsService.selectedCompany" (selectionChange)="layout.onSelectedCompany($event.value)">
        <input id="search" placeholder="Arama" (keyup)="onKey($event.target.value)">
        <mat-option *ngFor="let company of _appsService.filterCompanies" [value]="company.id">
          {{company.companyName}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field >
      <mat-select style="font-size: 15px;" [(value)]="_appsService.selectedProject" (selectionChange)="layout.onSelectedProject($event.value)">
        <mat-option *ngFor="let project of _appsService.projects" [value]="project.projectId">
          <span [ngClass]="project.parentId ? 'child-project':'parent-project'">{{project.projectName}}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>-->
      <!--<div class="row" style="height: 100%; display: flex; justify-content: center; align-items: center;  font-weight:300;">
      <button mat-button class="centered-button" style="display: flex; align-items: center; padding: 8px 16px; font-size: 14px; font-weight: 500;">
        <img src="../../../../assets/icons/help.png" alt="help" class="centered-image" style="width: 24px; height: 24px; vertical-align: middle; margin-right: 8px;">
        <span style="line-height: 1;">{{'help' | translate}}</span>
      </button>
    </div>-->

      <img *ngIf="_appsService.logoUrl" style="margin-right:24px; max-width:120px; max-height: -webkit-fill-available; padding:5px 0" [src]="_appsService.logoUrl" />
      
      <!-- Tutorial Menu -->
      <app-tutorial-menu></app-tutorial-menu>
      
      <app-notifications></app-notifications>

      <h1 *ngIf="!mobileQuery.matches" style="margin-right:10px;margin-left:10px;"></h1>
      <app-user (signOut)="signOut()" (profileStatus)="getCurrentStatus($event)"></app-user>
    </div>
  </div>

</mat-toolbar>



